
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contributors",
      function () {
        return require("private-next-pages/contributors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contributors"])
      });
    }
  